import { render, staticRenderFns } from "./FoodcourtClaimsList.vue?vue&type=template&id=30ab04fc&scoped=true"
import script from "./FoodcourtClaimsList.vue?vue&type=script&lang=js"
export * from "./FoodcourtClaimsList.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtClaimsList.vue?vue&type=style&index=0&id=30ab04fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab04fc",
  null
  
)

export default component.exports